import React from 'react'

const NoResult = (props)=> {
  const {title, description} = props;
  return (
    <>
      <div className="text-black text-center p-5 mb-4 bg-white rounded-lg">
        {title && <h4 className="mb-4 text-base text-ek-grey-400 font-bold leading-[27px] tracking-[0.36px]">{title}</h4>}
        {description && <div className="text-base text-ek-grey-400 font-normal leading-6 tracking-[0.64px]"><p>{description}</p></div>}
      </div>
    </>
  )
}
export default NoResult;
